import ProjectApi from '@api/projects.api';
import DocumentApi from '@api/document.api';
import ListApi from '@api/lists.api';
const handleNavigationData = {
   async getData(route) {
    let data = {
        title: '',
        url: '',
        icon: '',
    }
    
    const routeTitle = route.meta?.title || route.name || '';
    if(route.name === 'login' || route.name === 'login_loading') {
        return data;
    }
    
    // Check if route has query parameters
    const hasQueryParams = route.query && Object.keys(route.query).length > 0;
    
    // Helper function to add " - Filtered" suffix and page number
    const addFilteredSuffix = (title) => {
        if (!hasQueryParams) {
            return title;
        }
        
        let filteredTitle = title + ' - Filtered';
        
        // Add page number if present and not page 1
        const page = route.query.page;
        if (page && page !== '1') {
            filteredTitle += ' - Page ' + page;
        }
        
        return filteredTitle;
    };
    
    switch(route.name) {
        case 'home':
            data = {
                title: addFilteredSuffix(routeTitle || 'Home'),
                url: route.fullPath || route.path || '/home',
                icon: 'home',
            };
            break;
        case 'projects':
            data = {
                title: addFilteredSuffix(routeTitle || 'Projects'),
                url: route.fullPath || route.path || '/projects',
                icon: 'project',
            };
            break;
        case 'documents':
            data = {
                title: addFilteredSuffix(routeTitle || 'Documents'),
                url: route.fullPath || route.path || '/documents',
                icon: 'document',
            };
            break;
        case 'lists':
            let title = '';
            if(route.query.ListType == 'my_list'){
                title = 'My List'
            }else{
                title = 'Shared List'
            }
            data = {
                title: addFilteredSuffix(title),
                url: route.fullPath || route.path || '/lists',
                icon: 'list',
            };
            break;
        case 'users':
            data = {
                title: addFilteredSuffix(routeTitle || 'Users'),
                url: route.fullPath || route.path || '/users',
                icon: 'tamer',
            };
            break;
        case 'my.knowledge':
            data = {
                title: addFilteredSuffix(routeTitle || 'My Knowledge'),
                url: route.fullPath || route.path || '/my-knowledge',
                icon: 'activity',
            };
            break;
        case 'requests':
            data = {
                title: addFilteredSuffix(routeTitle || 'Requests'),
                url: route.fullPath || route.path || '/requests',
                icon: 'request',
            };
            break;
        case 'projects-requests':
            data = {
                title: addFilteredSuffix(routeTitle || 'Projects Requests'),
                url: route.fullPath || route.path || '/projects-requests',
                icon: 'projects-request',
            };
            break;
        case 'documents-requests':
            data = {
                title: addFilteredSuffix(routeTitle || 'Documents Requests'),
                url: route.fullPath || route.path || '/documents-requests',
                icon: 'documents-request',
            };
            break;
        case 'analytics':
            data = {
                title: addFilteredSuffix(routeTitle || 'Analytics'),
                url: route.fullPath || route.path || '/analytics',
                icon: 'analytics',
            };
            break;
        case 'search':
            const keyword = route.query?.Keyword || '';
            // Construct URL with query parameters to ensure uniqueness
            let searchUrl = route.fullPath;
            if (!searchUrl && route.path) {
                // Build URL with query parameters if fullPath is not available
                const queryString = route.query && Object.keys(route.query).length > 0 
                    ? '?' + new URLSearchParams(route.query).toString() 
                    : '';
                searchUrl = route.path + queryString;
            }
            searchUrl = searchUrl || '/search';
            
            // Only save search if there's a valid keyword
            if (keyword) {
                data = {
                    title: 'Search Results for "' + keyword + '"',
                    url: searchUrl,
                    icon: 'search',
                };
            } else {
                // If no keyword, use default search page
                data = {
                    title: addFilteredSuffix(routeTitle || 'Search'),
                    url: searchUrl,
                    icon: 'search',
                };
            }
            break;
        case 'projects.view':
            data = await this.GetProjectData(route.params.id, route);
            break;
        case 'lists.view':
            data = await this.GetListData(route.params.id, route);
            break;    
        case 'documents.view':
            data = await this.GetDocumentData(route.params.id, route);
            break;
        case 'documents.category':
            data = {
                title: addFilteredSuffix(routeTitle || 'Documents'),
                url: route.fullPath || route.path || '/documents',
                icon: 'document',
            };
            break;
        default:
            if (route.path && route.path !== '/') {
                data = {
                    title: addFilteredSuffix(routeTitle || route.name || 'Page'),
                    url: route.fullPath || route.path,
                    icon: 'setting',
                };
            }
            break;
    }
    return data;
   },

    GetProjectData(id, route = null) {
        const fullPath = route?.fullPath || `/projects/${id}`;
        return ProjectApi.get({id: id})
            .then(response => {
                return {
                    title: response.data.data?.project?.title,
                    url: fullPath,
                    icon: 'project',
                };
            })
            .catch(error => {
                console.log(error);
                return {
                    title: '',
                    url: '',
                    icon: '',
                };
            });
        
   },

    GetDocumentData(id, route = null) {
        const fullPath = route?.fullPath || `/documents/${id}`;
        return DocumentApi.get({id: id})
        .then(response => {
            return {
                title: response.data.data?.Document?.title || response.data.data?.document?.title || `Document ${id}`,
                url: fullPath,
                icon: 'document',
            };
        })
        .catch(error => {
            console.log('GetDocumentData error:', error);
          
            return {
                title: '',
                url: '',
                icon: '',
            };
        });
    },

    GetListData(id, route = null) {
        const fullPath = route?.fullPath || `/lists/${id}`;
        return ListApi.get({id: id})
        .then(response => {
            return {
                title: response.data.data?.list?.name || `List ${id}`,
                url: fullPath,
                icon: 'list',
            };
        })
        .catch(error => {
            console.log('GetListData error:', error);
          
            return {
                title: '',
                url: '',
                icon: '',
            };
        });
    }    

};

export default handleNavigationData;